"use client";

import "./ProblemSolveSection.scss";

import "swiper/css";
import "swiper/css/autoplay";
import ScrollingTagsBanner from "@/components/ScrollingTagsBanner/ScrollingTagsBanner";

const ProblemSolveSection = ({ data }) => {
  const { title, cases, image } = data;
  return (
    <ScrollingTagsBanner
      title={title}
      image={image}
      imageAlt="Problems Project Pulse Solves"
      items={cases}
    />
  );
};

export default ProblemSolveSection;
